module.exports = __webpack_public_path__ + "img/red_054.850a37fa.png";